/*
 * @package           Zorg CMS
 * @author            Dru
 * @copyright         Copyright (c) 2008 - 2023, Belder Interactive s.a.s.
 * @link              https://www.belder.com
 * @version           3.2
 */

window.loaded = {}

window.loadJs = (src, callback) => {
	if (window.loaded[src] > 0) {
		let inter = setInterval(() => {
			if (window.loaded[src] === 2) {
				callback();
				clearInterval(inter);
			}
		}, 500);
		return;
	}
	window.loaded[src] = 1;
	let js             = document.createElement('script');
	js.onload          = () => {
		window.loaded[src] = 2;
		callback();
	}
	js.src             = src;
	document.head.appendChild(js);
}

window.loadCss = (src) => {
	if (window.loaded[src]) return;
	window.loaded[src] = true;
	let css            = document.createElement('link');
	css.media          = 'all';
	css.rel            = 'stylesheet';
	css.href           = src;
	document.head.appendChild(css);
}